export { Tabs } from "@mantine/core";
export type {
  TabsProps,
  TabsTabProps,
  TabsListProps,
  TabsPanelProps,
} from "@mantine/core";
export { tabsOverrides } from "./Tabs.config";
